import { ICoordinate } from './coordinate.interface';
import { RouteStatusEnum } from '../enums/route-status.enum';

export interface ICreateRouteInputDto {
    organizationId?: string;
    name: string;
    status: RouteStatusEnum;
    fileUrl?: string;
    origin?: ICoordinate;
    destination?: ICoordinate;
}
